import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import moment from 'moment-timezone'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

interface Props {
  fieldName: string
}

function LocationScansRow({ fieldName }: Props): JSX.Element {
  const classes = useStyles()

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.createdAt`}>
          {({ input }) => (
            <p>
              {moment
                .unix(input.value)
                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .format('M/D/YY h:mm A z')}
            </p>
          )}
        </Field>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.locationName`}>{({ input }) => <p>{input.value}</p>}</Field>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.userEmail`}>
          {({ input }) => (input.value ? <p>{input.value}</p> : '--')}
        </Field>
      </TableCell>
    </TableRow>
  )
}

export default memo(LocationScansRow)
